
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getChartRecord, cycleCheckList } from '../../api/cyclCheck';

import DialogSelecedtName from './components/BranchDialog.vue';
var echarts = require('echarts');

var that:any = '';

@Component({
  name: 'BranchCheckRecordAlone',
  components: {
    DialogSelecedtName
  }
})

export default class extends Vue {
  private searchForm:any = {
    name: '',
    branchCompanyId: '',
    time: '',
    event: '',
    containBranch: false
  }
  private checkboxDisabled=true;
  private eventOptions = []
  private selecedtNameVisible = false
  private selectedNameReadonly = false

  @Watch('selecedtNameVisible', {
    immediate: true
  })toggleVisible(val: boolean) {
    if (val) {
      this.selectedNameReadonly = true;
    } else {
      this.selectedNameReadonly = false;
    }
  }

  private echartsA = {
    finish: 0,
    unfinish: 0
  }
  @Watch('echartsA', {
    deep: true,
    immediate: false
  }) handleChangeChartsA() {
    this.echartsDataA();
  }

  private echartsB = {
    normal: 0,
    unnormal: 0
  }
  @Watch('echartsB', {
    deep: true,
    immediate: false
  }) handleChangeChartsB() {
    this.echartsDataB();
  }

  mounted() {
    this.echartsDataA();
    this.echartsDataB();
  }
  private search() {
    if (this.searchForm.time && this.searchForm.time.length > 0) {
      this.startTime = new Date(this.searchForm.time[0].replace(/-/g, '/') + ' 00:00').getTime().toString().substring(0, 10);
      this.endTime = new Date(this.searchForm.time[1].replace(/-/g, '/') + ' 00:00').getTime().toString().substring(0, 10);
      this.titleTimeStr = this.searchForm.time[0] + '至' + this.searchForm.time[1] + '点检情况';
    } else {
      this.startTime = '';
      this.endTime = '';
      this.titleTimeStr = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + '点检情况';
    }
    this.getChartRecord();
  }
  private restSearchData() {
    this.checkboxDisabled = true;
    this.searchForm = {
      name: '',
      branchCompanyId: '',
      time: '',
      event: '',
      containBranch: false
    };
    this.startTime = '';
    this.endTime = '';
    this.titleTimeStr = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + '点检情况';
    this.getChartRecord();
  }
  private titleTimeStr=new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + '点检情况';

  private startTime='';
  private endTime='';
  private getChartRecord() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.contain_branch = this.searchForm.containBranch ? 1 : 0;
    params.start_time = this.startTime;
    params.end_time = this.endTime;
    if (this.searchForm.branchCompanyId) {
      params.branch_company_id = this.searchForm.branchCompanyId;
    }
    if (this.searchForm.event) {
      params.cycle_check_id = parseInt(this.searchForm.event.sync_id) !== 0 ? this.searchForm.event.sync_id : this.searchForm.event.id;
    }
    getChartRecord(params).then(res => {
      if (res.data) {
        this.echartsA.unfinish = res.data.unfinish;
        this.echartsA.finish = res.data.finish;
        this.echartsB.normal = res.data.normal;
        this.echartsB.unnormal = res.data.unnormal;
      } else {
        this.echartsA.unfinish = 0;
        this.echartsA.finish = 0;
        this.echartsB.normal = 0;
        this.echartsB.unnormal = 0;
      }
    }).catch(err => {
      this.echartsA.unfinish = 0;
      this.echartsA.finish = 0;
      this.echartsB.normal = 0;
      this.echartsB.unnormal = 0;
      let erra = err;
    });
  }

  // 获取事件列表
  private getCheckList(companyId:any) {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = companyId;
    cycleCheckList(params).then(res => {
      if (res.data != null && res.data.list && res.data.list.length > 0) {
        this.eventOptions = res.data.list;
      } else {
        this.eventOptions = [];
      }
    }).catch(err => {
      this.eventOptions = [];
      let erra = err;
    });
  }
  private clearCompany() {
    this.searchForm.containBranch = false;
    this.checkboxDisabled = true;
    this.searchForm.branchCompanyId = '';
  }
  private selectedNameHandle() {
    this.selecedtNameVisible = true;
  }
  private selectBranch(branch:any) {
    this.checkboxDisabled = false;
    this.searchForm.name = branch.name;
    this.searchForm.branchCompanyId = branch.id;
    this.selecedtNameVisible = false;
  }
  private selecedtNameClose(val: boolean) {
    this.selecedtNameVisible = val;
  }
  created() {
    this.getChartRecord();
    this.getCheckList(UserModule.getCompanyId);
  }
  beforeCreate() {
    that = this;
  }

  private echartsDataA() {
    let myChartsta = echarts.init(document.getElementById('branch-echarts-TA'));
    let option = {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        x: 'left',
        data: ['未点检', '已点检']
      },
      series: [
        {
          name: '当前状态',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            formatter: function(params: any) {
              if ((params.percent + '').indexOf('.') > -1) {
                return params.percent.toFixed(2) + '%';
              } else {
                return params.percent + '%';
              }
            },
            position: 'inside',
            emphasis: {
              show: true,
              textStyle: {
                fontSize: '30',
                fontWeight: 'normal'
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [ {
            value: this.echartsA.unfinish,
            name: '未点检'
          }, {
            value: this.echartsA.finish,
            name: '已点检'
          }]
        }
      ],
      color: ['#d54348', '#497bb2']
    };

    myChartsta.setOption(option);

    myChartsta.on('click', function(data: any) {
      let query:any = that.$data.searchForm;
      query.checkboxDisabled = that.$data.checkboxDisabled;
      query.startTime = that.$data.startTime;
      query.endTime = that.$data.endTime;
      if (data.dataIndex === 0) {
        query.last_check_state = 0;
        that.$router.push({
          path: '/Branch/branchCheckRecordListAlone',
          query: { 'pamars': JSON.stringify(query) }
        });
      } else {
        query.last_check_state = 9;
        that.$router.push({
          path: '/Branch/branchCheckRecordListAlone',
          query: { 'pamars': JSON.stringify(query) }
        });
      }

      // let params = '?is_branch=1&is_day=1&';

      // if (data.dataIndex === 0) {
      //   // 未点检
      //   window.open('#/Branch/checkRecordList' + params + 'last_check_state=0');
      // } else if (data.dataIndex === 1) {
      //   // 已点检
      //   window.open('#/Branch/checkRecordList' + params + 'last_check_state=9');
      // }
    });
  }

  private echartsDataB() {
    let myChartsta = echarts.init(document.getElementById('branch-echarts-TB'));
    let option = {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'vertical',
        x: 'left',
        data: ['异常', '正常']
      },
      series: [
        {
          name: '当前状态',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            formatter: function(params: any) {
              if ((params.percent + '').indexOf('.') > -1) {
                return params.percent.toFixed(2) + '%';
              } else {
                return params.percent + '%';
              }
            },
            position: 'inside',
            emphasis: {
              show: true,
              textStyle: {
                fontSize: '30',
                fontWeight: 'normal'
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [{
            value: this.echartsB.unnormal,
            name: '异常'
          }, {
            value: this.echartsB.normal,
            name: '正常'
          }]
        }
      ],
      color: ['#d54348', '#497bb2']
    };

    myChartsta.setOption(option);

    myChartsta.on('click', function(data:any) {
      let query:any = that.$data.searchForm;
      query.checkboxDisabled = that.$data.checkboxDisabled;
      query.startTime = that.$data.startTime;
      query.endTime = that.$data.endTime;
      if (data.dataIndex === 0) {
        query.last_check_state = 2;
        that.$router.push({
          path: 'checkRecordList',
          query: { 'pamars': JSON.stringify(query) }
        });
      } else {
        query.last_check_state = 1;
        that.$router.push({
          path: 'checkRecordList',
          query: { 'pamars': JSON.stringify(query) }
        });
      }

      // let params = '?is_branch=1&is_day=1&';

      // if (data.dataIndex === 0) {
      //   // 异常
      //   window.open('#/Branch/checkRecordList' + params + 'last_check_state=2');
      // } else if (data.dataIndex === 1) {
      // // 正常
      //   window.open('#/Branch/checkRecordList' + params + 'last_check_state=1');
      // }
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
